import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { OdontoOdontogramViewModel } from 'src/app/model/odonto/odontogram.view';
import { OdontoSymbologyModel } from 'src/app/model/odonto/symbology';
import { ODONTO_MODULE_CONSTANTS } from '../../odonto.constants';

@Component({
  selector: 'ms-odonto-odontogram',
  templateUrl: './odonto.odontogram.component.html',
  styleUrls: ['./odonto.odontogram.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OdontoOdontogramComponent,
      multi: true,
    },
  ],
})
export class OdontoOdontogramComponent extends BaseValueAccessor<
  OdontoOdontogramViewModel[] | undefined
> {
  readonly screen = ODONTO_MODULE_CONSTANTS;
  @Input() turn = -1;
  @Input() symbology?: OdontoSymbologyModel[] = [];
  cmItems: MenuItem[] = [];
  selectedSymbology?: OdontoSymbologyModel;

  private sidePath: {
    [key: string]: {
      [key: string]: string;
    };
  } = {
    V: {
      T: 'M 100 100 L 190 10 A 20 20 0 0 0 175 5 L 25 5 A 20 20 0 0 0 10 10 Z',
      L: 'M 100 100 L 10 10 A 20 20 0 0 0 5 25 L 5 175 A 20 20 0 0 0 10 190 Z',
      B: 'M 100 100 L 10 190 A 20 20 0 0 0 25 195 L 175 195 A 20 20 0 0 0 190 190 Z',
      R: 'M 100 100 L 190 190 A 20 20 0 0 0 195 175 L 195 25 A 20 20 0 0 0 190 10 Z',
      C: 'M 150 50 L 50 50 L 50 150 L 150 150 Z',
    },
    L: {
      T: 'M 100 100 L 195 100 A 100 100 0 0 0 100 5 Z',
      L: 'M 100 100 L 100 5 A 100 100 0 0 0 5 100 Z',
      B: 'M 100 100 L 5 100 A 100 100 0 0 0 100 195 Z',
      R: 'M 100 100 L 100 195 A 100 100 0 0 0 195 100 Z',
      C: 'M 150 100 A 85 85 0 0 0 100 50 A 85 85 0 0 0 50 100 A 85 85 0 0 0 100 150 A 85 85 0 0 0 150 100 Z',
    },
  };

  handleSectionClick = (
    $event: MouseEvent,
    section: OdontoOdontogramViewModel
  ) => {
    $event.preventDefault();
    switch (section.color) {
      case undefined:
      case 'white':
        section.color = 'red';
        break;
      case 'red':
        section.color = 'blue';
        break;
      case 'blue':
        section.color = 'white';
        break;
    }
    section.changed = true;
  };

  buildPathBySide = (type: string, side: string) => this.sidePath[type][side];

  handleDropTeeth = (teeth: OdontoOdontogramViewModel) => {
    if (teeth.symbology === this.selectedSymbology?.id) {
      delete teeth.symbology;
      delete teeth.symbologyIcon;
      delete teeth.symbologyColor;
    } else {
      teeth.symbology = this.selectedSymbology?.id;
      teeth.symbologyIcon = this.selectedSymbology?.icon;
      teeth.symbologyColor = this.selectedSymbology?.color;
    }
    teeth.changed = true;
  };
}
